export const RECTANGLE_WARP = 'RectangleWarp';
export const PERSPECTIVE_WARP = 'PerspectiveWarp';
export const CYLINDER_WARP = 'CylinderWarp';
export const SMOOTH_WARP = 'SmoothWarp';
export const TEXTURE_WARP = 'TextureWarp';
/** Auto-placed apparel warp — a `RectangleTransformType` whose coordinates are computed from
 * flat-garment landmark markers and DIS/size-chart data, with an explicit "Recompute Placement"
 * action. Not part of the shared CIM/Dip XML vocabulary — serialized as an ordinary `RectangleWarp`
 * with accompanying metadata for persistence. */
export const GARMENT_WARP = 'GarmentWarp';

export type DocumentWarp =
    | typeof RECTANGLE_WARP
    | typeof PERSPECTIVE_WARP
    | typeof CYLINDER_WARP
    | typeof SMOOTH_WARP
    | typeof TEXTURE_WARP
    | typeof GARMENT_WARP;

export const DOCUMENT_ID = 'Document';
